import styled from 'styled-components';
import theme from 'src/theme';

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0.25rem !important;
    background: ${theme.legacyColors.headingPanelBgColor};
`;

export const TextContent = styled.div`
    margin-left: 0.5rem;

    h3 {
        color: ${theme.legacyColors.primaryTextColor};
    }
    @media only screen and (max-width: 1440px) {
        h3 {
            font-size: 0.6rem;
        }
    }
`;

export const SortButtonWrapper = styled.div`
    position: absolute;
    top: 13px;
    right: 0;
`;

export const FromToWrapper = styled.div`
    display: inline-block;
    position: relative;
    font-size: 0.7rem;
    font-weight: 400;
`;

export const ClearFilterIcon = styled.div`
    cursor: pointer;
    position: absolute;
    right: -12px;
    top: -6px;
    color: ${(props) => props.theme.primaryTextColor};
    ${(props) => props.theme.clickableIcon};
`;
